// import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import Header from "../component/header/Header";
import Sidebar from "../component/sidebar/Sidebar";
import "./index.css";
import { StoreContext } from "../../store";
import MainLayoutMts from "../../../components/common/Layout/MainLayout";

function MainLayout(props) {
  // const [collapsed, setCollapsed] = useState(false);
  const context = useContext(StoreContext);

  useEffect(() => {
    // axios
    //   .get("http://dev.sflhub.com/ordermanagementapi/api/v1/Order/getVolume")
    //   .then((res) => {
    //     console.log(res);
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  }, []);

  return (
    // <div className="_afterAuthCommon">
    //   <Sidebar />
    //   <div
    //     className={
    //       context.collapsed
    //         ? "_afterAuthHeader_Main expand"
    //         : "_afterAuthHeader_Main"
    //     }
    //   >
    //     <Header title={props.title ?? ""} />
    //     {props.children}
    //   </div>
    // </div>
    <MainLayoutMts>{props.children}</MainLayoutMts>
  );
}

export default MainLayout;
